<div class="fui-content-filter">
  <div class="d-flex align-items-center flex-wrap">
    @if (showSidebarToggle) {
      <button class="text-nowrap m-y-5 refine-btn" (click)="refine()">
        <fa-icon [icon]="refining ? 'chevron-left' : 'bars'"></fa-icon>
        {{ refining ? ("my_gear.hide_filters" | translate) : ("my_gear.show_filters" | translate) }}
      </button>
      <button class="text-nowrap m-y-5 refine-btn-mobile" (click)="showMobileFilters()">
        <fa-icon icon="bars"></fa-icon>
        {{ "my_gear.show_filters" | translate }}
      </button>
    }

    @if (filters) {
      @if (filters.product != "any") {
        <div class="m-l-10 text-nowrap m-y-5">
          {{ "my_gear.product" | translate }}:
          {{ contentService.productsAssociatedWithVideosMap[filters.product] ? contentService.productsAssociatedWithVideosMap[filters.product].title : filters.product }}
          <button (click)="clearFilter.next('product')"><fa-icon icon="times"></fa-icon></button>
        </div>
      }
      @if (filters.tag != "any") {
        <div class="m-l-10 text-nowra m-y-5">
          {{ "my_gear.tag" | translate }}: {{ contentService.tagsAssociatedWithVideosMap[filters.tag] ? contentService.tagsAssociatedWithVideosMap[filters.tag].title : filters.tag }}
          <button (click)="clearFilter.next('tag')"><fa-icon icon="times"></fa-icon></button>
        </div>
      }
      @if (filters.duration != "any") {
        <div class="m-l-10 text-nowrap m-y-5">
          {{ "my_gear.duration" | translate }}: {{ contentService.durationMap[filters.duration] }}
          <button (click)="clearFilter.next('duration')"><fa-icon icon="times"></fa-icon></button>
        </div>
      }
    }
  </div>
  <!--
    Right-side control cluster (2026-09-01) — search input + sort/view/refresh pills +
    results count. Uses a shared `.fui-content-filter-right-cluster` class instead of
    each item carrying its own `m-l-*`/`m-r-*` margins so the spacing between items is
    consistent (single `gap: 12px` on the container). Individual items only carry
    layout-adjusting margins when they need to *break* out of the gap default.
  -->
  <div class="d-flex align-items-center fui-content-filter-right-cluster">
    @if (showSearchInput) {
      <div class="fui-sidebar-search" [class.wider]="widerSearch">
        <input
          type="text"
          [placeholder]="searchPlaceholder | translate"
          [(ngModel)]="activeQuery"
          id="content-filter-search"
          (keyup.enter)="queryChanged.next(activeQuery)"
          (ngModelChange)="queryChangedEvent($event)"
        />
        @if (activeQuery) {
          <button type="button" class="clear-query-btn" (click)="activeQuery = ''; clearQuery.next()">
            <fa-icon icon="times"></fa-icon>
          </button>
        }
      </div>
    }
    @if (showSortOptionsToggle) {
      <!--
        Sort cluster (2026-09-01 redesign) — replaces the "Sort by ›" text button + right-
        chevron with a small uppercase "SORT" label followed by a rounded pill that shows
        the CURRENT sort selection (e.g. "Date", "Title"). Chevron-down flips to up while
        the dropdown is open. Matches the design mockup and reads as a proper control
        surface instead of an inline text link.
      -->
      <div class="fui-content-filter-sort-by" (clickOutside)="showSortOptions = false">
        <span class="fui-content-filter-sort-label">{{ "my_gear.sort_by" | translate }}</span>
        <button
          type="button"
          class="fui-content-filter-sort-pill"
          (click)="showSortOptions = !showSortOptions"
          [attr.aria-expanded]="showSortOptions"
          [attr.aria-label]="('my_gear.sort_by' | translate) + ': ' + (currentSortLabelKey | translate)"
        >
          <span class="fui-content-filter-sort-pill-value">{{ currentSortLabelKey | translate }}</span>
          <fa-icon icon="chevron-down" [class.rotate180]="showSortOptions"></fa-icon>
        </button>
        <div class="sort-by-options" [showIf]="showSortOptions" animateIn="down">
          <div class="options">
            <button (click)="sortBy('abc')" class="m-b-5" [class.selected]="settings.sort_by == 'abc'">{{ "my_gear.title" | translate }}</button>
            <button (click)="sortBy('date')" [class.selected]="settings.sort_by == 'date'">{{ "my_gear.date" | translate }}</button>
          </div>
          <div class="direction">
            <button (click)="sortDirection('asc')" class="m-b-5" [class.selected]="settings.sort_direction == 'asc'">{{ "my_gear.ascending" | translate }}</button>
            <button (click)="sortDirection('desc')" [class.selected]="settings.sort_direction == 'desc'">{{ "my_gear.descending" | translate }}</button>
          </div>
        </div>
      </div>
    }
    @if (showViewOption && !isSmallViewport) {
      <!--
        View toggle — grouped inside a rounded pill container (2026-09-01 redesign). Two
        icon buttons paint their `.active` state with a subtle fill instead of the old
        opacity swap next to a "View" text label; label is dropped because the icons
        alone read as unambiguously as the mockup shows.
      -->
      <div class="fui-content-filter-view-as" role="group" aria-label="View">
        <button type="button" [class.active]="appService.prefersGrid" (click)="appService.prefersGrid = true" aria-label="Grid view"><fa-icon icon="table-cells-large"></fa-icon></button>
        <button type="button" [class.active]="!appService.prefersGrid" (click)="appService.prefersGrid = false" aria-label="List view"><fa-icon icon="bars"></fa-icon></button>
      </div>
    }
    @if (showRefreshButton) {
      <!--
        Refresh — icon-only pill (2026-09-01 redesign) that matches the sort/view
        treatment. Text label dropped because the sync icon reads as unambiguously as
        the mockup shows. `<div>` wrapper kept so vertical alignment inside the flex
        row lines up with sort/view siblings.
      -->
      <div>
        <button type="button" class="fui-content-filter-refresh" (click)="refresh()" [attr.aria-label]="'general.refresh' | translate">
          <fa-icon icon="sync" [animation]="refreshing ? 'spin' : undefined"></fa-icon>
        </button>
      </div>
    }
    @if (showResults) {
      <!--
        Results count is rendered LAST in the flex row so it sits at the far-right edge
        of the cluster (2026-09-01 reorder). Refresh moved to the left of it, alongside
        the sort/view pills, matching the design mockup.
      -->
      <div class="fui-content-filter-results">
        <span class="t-14 bold text-nowrap">{{ resultsCount }} {{ resultsCount == 1 ? ("my_gear.result_singular" | translate) : ("my_gear.results" | translate) }}</span>
      </div>
    }
  </div>
</div>
@if (showSearchInput) {
  <!--
    Mobile fallback search (shown by the `.fui-sidebar-search-full` `@media(max-width:800px)`
    swap). Previously rendered unconditionally, which meant `[showSearchInput]="false"`
    consumers (e.g. the secondary sort/view/results/refresh cluster on My Gear) still
    got a phantom search input on mobile. Gating on `showSearchInput` keeps its
    lifecycle in sync with the desktop version above.
  -->
  <div class="fui-sidebar-search-full">
    <input type="text" [placeholder]="'my_gear.search' | translate" [(ngModel)]="activeQuery" (keyup.enter)="queryChanged.next(activeQuery)" (ngModelChange)="queryChangedEvent($event)" />
    @if (activeQuery) {
      <button type="button" class="clear-query-btn" (click)="activeQuery = ''; clearQuery.next()">
        <fa-icon icon="times"></fa-icon>
      </button>
    }
  </div>
}
